import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { GetMeUserResponse } from '../interfaces/get-me-user';
import { RequestError } from '../../../interfaces/error.interface';
import { User } from '../../../interfaces/user.interface';
import { Course } from '../../../interfaces/course.interface';
import { GetMeCoursesResponse } from '../interfaces/get-me-courses';
import { StudentCourse } from '../../../interfaces/studentCourse.interface';
import { GetGoogleSyncResponse } from '../interfaces/get-google-sync';

export interface MeState {
  user: User | null;
  profesorCourses: Course[];
  studentCourses: StudentCourse[];
  isGoogleSynced: boolean;
  googleStatus: {
    synced: boolean;
    tokensValid: boolean;
    needsReconnect: boolean;
    lastError?: string;
  } | null;
  timezone: string;
  errorCode: number | null;
}

const initialState: MeState = {
  user: null,
  profesorCourses: [],
  studentCourses: [],
  isGoogleSynced: false,
  googleStatus: null,
  timezone: 'America/Santiago',
  errorCode: null,
};

const meSlice = createSlice({
  name: 'me',
  initialState,
  reducers: {
    getMeUserInitApiAction: (state) => {
      state.errorCode = null;
    },
    getMeUserSuccessApiAction: (
      state,
      action: PayloadAction<GetMeUserResponse>
    ) => {
      state.user = action.payload.user;
    },
    getMeUserFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    putMeUserInitApiAction: (state) => {
      state.errorCode = null;
    },
    putMeUserSuccessApiAction: () => {},
    putMeUserFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    putMePasswordInitApiAction: (state) => {
      state.errorCode = null;
    },
    putMePasswordSuccessApiAction: () => {},
    putMePasswordFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    getMeCoursesInitApiAction: (state) => {
      state.errorCode = null;
    },
    getMeCoursesSuccessApiAction: (
      state,
      action: PayloadAction<GetMeCoursesResponse>
    ) => {
      state.profesorCourses = action.payload.professorCourses;
      state.studentCourses = action.payload.studentCourses;
    },
    getMeCoursesFailureApiAction: (state, action: PayloadAction<RequestError>) => {
      state.errorCode = action.payload.errorCode;
    },
    getGoogleStatusSuccessApiAction: (state, action: PayloadAction<any>) => {
      state.googleStatus = action.payload;
    },
    setTimezoneAction: (state, action: PayloadAction<string>) => {
      state.timezone = action.payload;
    },
    meClearAction: (state) => {
      state.user = null;
      state.profesorCourses = [];
      state.studentCourses = [];
      state.googleStatus = null;
      state.isGoogleSynced = false;
      state.timezone = 'America/Santiago';
      state.errorCode = null;
    },
  },
});

export const {
  getMeUserInitApiAction,
  getMeUserSuccessApiAction,
  getMeUserFailureApiAction,
  putMeUserInitApiAction,
  putMeUserSuccessApiAction,
  putMeUserFailureApiAction,
  getMeCoursesInitApiAction,
  getMeCoursesSuccessApiAction,
  getMeCoursesFailureApiAction,
  putMePasswordInitApiAction,
  putMePasswordSuccessApiAction,
  putMePasswordFailureApiAction,
  getGoogleStatusSuccessApiAction,
  setTimezoneAction,
  meClearAction,
} = meSlice.actions;

export default meSlice.reducer;
